import React, { Component } from "react";
import { check } from "@xams-utils/check-types";

// import QRCode from "react-qr-code";

import { MfaVerify } from "../mfa-verify";
import { MfaNumber } from "../mfa-number";

import { MaterialText } from "components/presentation/material-text";
import Button from "@material-ui/core/Button";

import { api } from "libs/api/api";
import { ENDPOINTS } from "libs/api/constants";
import { MFA_AUTHENTICATION_TYPES } from "constants/multi-factor-authentication";
import {MESSAGE_IDS} from 'constants/message-ids'

class MfaEmailNotEnabled extends Component {
    state = {
        emailError: false,
        emailSent: false,
        sendingEmail: false,
        originalEmailSent: false,
    };

    constructor(props) {
        super(props);

        this.handleSendEmail = this.handleSendEmail.bind(this);
    }

    displayLineTitle() {
        const { classes, title } = this.props;

        return (
            <div className={classes.line}>
                <MaterialText>{title}</MaterialText>
            </div>
        );
    }

    displayLineOne() {
        const { emailSent, sendingEmail, originalEmailSent } = this.state;
        const { classes, messages } = this.props;
        const buttonMessageText=messages[MESSAGE_IDS.MFA.EMAIL_SEND_BUTTON]
        const buttonMessages=check.nonEmptyString(buttonMessageText)?buttonMessageText.split(","):["","",""]
        const buttonText =
            originalEmailSent || emailSent
                ? buttonMessages[0]
                : sendingEmail
                ? buttonMessages[1]
                : buttonMessages[2];

        return (
            <div>
                <div className={classes.line}>
                    <div className={classes.number}>
                        <MfaNumber number={1} />
                    </div>
                    <MaterialText>
                        {messages[MESSAGE_IDS.MFA.EMAIL_STEP_1]}
                    </MaterialText>
                </div>
                {this.displaySendEmailButton(
                    buttonText,
                    originalEmailSent || sendingEmail
                )}
            </div>
        );
    }

    displayLineTwo() {
        const { originalEmailSent, emailError, sendingEmail } = this.state;
        const { userId, orgId, onVerify, classes, enabled,rememberMeDays, messages } = this.props;
        const verifyProps = {
            userId,
            orgId,
            onVerify,
            enabled,
            mfaOption: MFA_AUTHENTICATION_TYPES.EMAIL,
            rememberMeDays,
            messages
        };

        if (!originalEmailSent) {
            return null;
        }

        return (
            <div className={classes.line}>
                <div className={classes.number}>
                    <MfaNumber number={2} />
                </div>
                {sendingEmail ? (
                    <div>
                        <MaterialText>Resending Email.</MaterialText>
                    </div>
                ) : emailError ? (
                    <div>
                        <MaterialText>
                           {messages[MESSAGE_IDS.MFA.EMAIL_PROBLEM]}
                        </MaterialText>
                    </div>
                ) : (
                    <div>
                        <MaterialText>
                        {messages[MESSAGE_IDS.MFA.EMAIL_STEP_2]}
                        </MaterialText>
                        <div className={classes.verify}>
                            <MfaVerify {...verifyProps} />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    displayLineThree() {
        const { originalEmailSent, emailSent, emailError, sendingEmail } =
            this.state;

        if (!originalEmailSent) {
            return null;
        }

        const { classes, messages } = this.props;
        const buttonMessage=messages[MESSAGE_IDS.MFA.EMAIL_RESEND_BUTTON].split(",")
        const buttonText = sendingEmail
            ? buttonMessage[0]
            : buttonMessage[1];
        const text = emailError
            ? messages[MESSAGE_IDS.MFA.EMAIL_ERROR]
            : messages[MESSAGE_IDS.MFA.EMAIL_STEP_3];

        return (
            <div>
                <div className={classes.line}>
                    <div className={classes.number}>
                        <MfaNumber number={3} />
                    </div>
                    <div>
                        <div>
                            <MaterialText>{text}</MaterialText>
                        </div>
                    </div>
                </div>
                {this.displaySendEmailButton(buttonText, sendingEmail)}
            </div>
        );
    }

    displayEmailError() {
        const {messages}=this.props;
        return (
            <MaterialText>
                {messages[MESSAGE_IDS.MFA.EMAIL_PROBLEM]}
            </MaterialText>
        );
    }

    displaySendEmailButton(title, disabled) {
        const { classes } = this.props;
        const buttonProps = {
            variant: "contained",
            color: "primary",
            className: classes.button,
            onClick: this.handleSendEmail,
            disabled,
        };
        return (
            <div className={classes.emailButton}>
                <Button {...buttonProps}>{title}</Button>
            </div>
        );
    }

    handleSendEmail() {
        const { userId } = this.props;

        this.setState(
            {
                emailSent: false,
                emailError: false,
                sendingEmail: true,
            },
            () => {
                api.get(ENDPOINTS.MFA.SEND_EMAIL, { userID: userId })
                    .then((response) => {
                        let error=true
                        if (response) {
                            const obj = JSON.parse(response);

                            if (check.nonEmptyObject(obj) && obj.email) {
                                error=false;
                                this.setState({
                                    sendingEmail: false,
                                    emailSent: true,
                                    originalEmailSent: true,
                                });
                            }
                        }

                        if (error) {
                            this.setState({
                                emailError: true,
                                sendingEmail: false,
                                originalEmailSent: true,
                            });
                        }
                    })
                    .catch(() => {
                        this.setState({
                            emailError: true,
                            sendingEmail: false,
                            originalEmailSent: true,
                        });
                    });
            }
        );
    }

    render() {
        return (
            <div>
                {this.displayLineTitle()}
                <div>
                    {this.displayLineOne()}
                    {this.displayLineTwo()}
                    {this.displayLineThree()}
                </div>
            </div>
        );
    }
}

export { MfaEmailNotEnabled };
